import { stringify } from "csv-string";
import iconv from "iconv-lite";

import { generateFilename } from "./FilenameUtils";
import { saveFile } from "../../commons/src/helpers/FileHelper";

export const table2CSV = (el, args) => {
    const options = {
        headerSelector: "th",
        columnSelector: "td",
        ...args
    };

    return downloadFile(buildBody(buildHeaders()));

    function buildHeaders() {
        let csvdata = "";
        const row = getVisibleRow(el, options.headerSelector);
        row.unshift("Type");
        csvdata = createCSVRow(row);
        return csvdata;
    }

    function buildBody(csvdata) {
        const nodeList = el.querySelectorAll("tr");

        for (let i = 0; i < nodeList.length; i++) {
            const tmpRow = getVisibleRow(nodeList[i], options.columnSelector);

            if (nodeList[i].classList.contains("total-row")) {
                tmpRow.unshift("");
            } else if (nodeList[i].classList.contains("investment-transaction")) {
                tmpRow.unshift("Sub transaction");
            } else if (nodeList[i].classList.contains("transaction-event")) {
                tmpRow.unshift("Transaction");
            }

            if (tmpRow.length > 0) {
                csvdata = csvdata + createCSVRow(tmpRow);
            }
        }
        return csvdata;
    }

    function getVisibleRow(context, selector) {
        const row = [];
        const nodeList = context.querySelectorAll(selector);

        for (let i = 0; i < nodeList.length; i++) {
            row[row.length] = cleanData(nodeList[i].textContent);
        }
        return row;
    }

    function createCSVRow(row) {
        return stringify(row);
    }

    function cleanData(input) {
        return input.replace(new RegExp(/£/g), "");
    }

    function downloadFile(data) {
        const isoString = iconv.encode(data, "ISO-8859-1");
        const blob = new Blob([isoString], { type: "text/csv;charset=ISO-8859-1" });
        const filename = generateFilename(
            options.client ? options.client.forename + " " + options.client.surname : undefined,
            options.details.accountNumber,
            options.startDate,
            options.endDate,
            ".csv"
        );
        saveFile(blob, filename);
        return true;
    }
};
